import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./style/index.scss?vue&type=style&index=0&id=5656fa44&lang=scss&scoped=true&external"
import "./index.vue?vue&type=style&index=1&id=5656fa44&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5656fa44"]])

export default __exports__